import React, { Component } from 'react';
import { Card, Input, Button } from 'antd';
import { EditOutlined, DeleteOutlined, SaveOutlined, CloseOutlined } from '@ant-design/icons';
import * as actions from '../../../store/actions';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import moment from 'moment';
import { withTranslation } from 'react-i18next';

import styles from './ViewNotes.scss';

const { TextArea } = Input;

class ViewNotes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      curr_note: '',
      editMode: '',
      hoveredCard: null,
    };
  }

  handleChange = e => {
    this.setState({ curr_note: e.target.value });
  };

  handleEdit = note_id => {
    const note = this.props.notes.find(n => n.id === note_id);
    this.setState({ editMode: note_id, curr_note: note ? note.data : '' });
  };

  handleCancel = () => {
    this.setState({ editMode: '', curr_note: '' });
  };

  handleDelete = (note_id, fire_time) => {
    this.props.deleteNote(note_id, fire_time);
    this.setState({ editMode: '', curr_note: '' });
  };

  handleSave = (note_id, fire_time) => {
    if (this.state.curr_note && this.state.curr_note.trim()) {
      this.props.editNote(note_id, fire_time, this.state.curr_note.trim());
    }
    this.setState({ editMode: '', curr_note: '' });
  };

  handleMouseEnter = noteId => {
    this.setState({ hoveredCard: noteId });
  };

  handleMouseLeave = () => {
    this.setState({ hoveredCard: null });
  };

  render() {
    const { t } = this.props;

    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        {this.props.notes.map(item => (
          <Card
            key={item.id}
            size="small"
            data-testid="note-item"
            style={{
              position: 'relative',
              borderRadius: '8px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
              backgroundColor: '#F9FDFF',
            }}
            onMouseEnter={() => this.handleMouseEnter(item.id)}
            onMouseLeave={this.handleMouseLeave}
          >
            {item.id === this.state.editMode ? (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <TextArea
                  value={this.state.curr_note}
                  onChange={this.handleChange}
                  data-testid="note-edit-input"
                  autoSize={{ minRows: 2, maxRows: 6 }}
                  placeholder={t('notes.edit_placeholder')}
                  style={{ backgroundColor: 'white' }}
                />
                <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                  <Button
                    size="small"
                    onClick={this.handleCancel}
                    data-testid="note-edit-cancel"
                    icon={<CloseOutlined />}
                  >
                    {t('notes.cancel')}
                  </Button>
                  <Button
                    type="primary"
                    size="small"
                    onClick={() => this.handleSave(item.id, item.fire_time)}
                    data-testid="note-edit-save"
                    icon={<SaveOutlined />}
                  >
                    {t('notes.save')}
                  </Button>
                </div>
              </div>
            ) : (
              <div>
                <pre
                  style={{
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word',
                    margin: 0,
                    fontFamily: 'inherit',
                    fontSize: '14px',
                    lineHeight: '1.5',
                  }}
                >
                  {item.data}
                </pre>
                <div
                  style={{
                    marginTop: '8px',
                    fontSize: '12px',
                    color: '#8c8c8c',
                    textAlign: 'right',
                  }}
                >
                  {moment(item.fire_time).format('HH:mm')}
                </div>
              </div>
            )}

            {/* Hover Actions */}
            {this.state.hoveredCard === item.id && item.id !== this.state.editMode && (
              <div
                style={{
                  position: 'absolute',
                  top: '8px',
                  right: '8px',
                  display: 'flex',
                  gap: '4px',
                  background: 'rgba(255,255,255,0.9)',
                  borderRadius: '4px',
                  padding: '4px',
                }}
              >
                <Button
                  type="text"
                  size="small"
                  icon={<EditOutlined />}
                  onClick={() => this.handleEdit(item.id)}
                  data-testid="note-edit-button"
                  aria-label={t('notes.edit')}
                  style={{ color: '#1890ff' }}
                />
                <Button
                  type="text"
                  size="small"
                  icon={<DeleteOutlined />}
                  onClick={() => this.handleDelete(item.id, item.fire_time)}
                  data-testid="note-delete-button"
                  aria-label={t('notes.delete')}
                  style={{ color: '#ff4d4f' }}
                />
              </div>
            )}
          </Card>
        ))}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    editNote: (note_id, fire_time, data) => dispatch(actions.editNote(note_id, fire_time, data)),
    deleteNote: (note_id, fire_time) => dispatch(actions.deleteNote(note_id, fire_time)),
  };
};

const mapStateToProps = state => {
  return {
    notes: state.events.notes,
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withTranslation('interview_container')(ViewNotes)),
);
